export const blueprintCategory = "blueprint-category";
export const demoEnv = "demo-env";
export const userDetails = "user-details";
export const userProfile = "user-profile";
export const userData = "user-data";
export const allApplicationUserRole = "all-application-user-role";
export const getBlueprintById = "get-blueprint-by-id-";
export const createNewBlueprint = "create-blueprint";
export const BlueprintsCategories = "blueprints-categories";
export const cloudTypes = "cloud-types";
export const subPillars = "sub-pillars";
export const blueprints = "blueprints";
export const regions = "regions";
export const accountsFromSf = "accounts_from_sf";
export const userDataFromSf ="user_data_from_sf"
export const opportunitiesByAccountId = "opportunities-by-account-id";
export const technicalEngagementByOpportunityID = "technicalEngagement-by-opportunity-id";
export const technicalEngagementByAccountID = "technicalEngagement-by-account-id";
export const pillars = "pillars";
export const cpx = "cpx";
export const updateCpx = "update-cpx";
export const createTeFromSf = "create-technicalEngagement-from-sf";
export const updateTeFromSf = "update-technicalEngagement-from-sf";
export const getThreatGuardCustomers = "get-threatguard-customers";
export const sendReports = "send-reports";

